import React, { useState, useCallback } from 'react';

export default function PlayAudio({ url, size = 'sm' }) {
  const [playing, setPlaying] = useState(false);

  const play = useCallback((e) => {
    e.stopPropagation();
    if (!url || playing) return;
    setPlaying(true);
    const audio = new Audio(url);
    audio.onended = () => setPlaying(false);
    audio.onerror = () => setPlaying(false);
    audio.play().catch(() => setPlaying(false));
  }, [url, playing]);

  if (!url) return null;

  const sizeClass = size === 'xs' ? 'w-5 h-5 text-[10px]' : size === 'sm' ? 'w-6 h-6 text-xs' : 'w-7 h-7 text-sm';

  return (
    <button
      onClick={play}
      className={`${sizeClass} rounded-full bg-[#2D6A4F]/10 hover:bg-[#2D6A4F]/20 text-[#2D6A4F] flex items-center justify-center transition-colors flex-shrink-0 ${playing ? 'animate-pulse' : ''}`}
      title="Listen"
    >
      🔊
    </button>
  );
}
